import React, {useState} from 'react'
import '../CardList.scss';
import {useDispatch, useSelector} from 'react-redux';
import {deleteBgItem} from '../../../api/common';
import moment from "moment";
import {professionScopes} from '../../../db/datasets/professions';
import {jobContracts} from '../../../db/models/const';
import AddIcon from "@material-ui/icons/Add";
import MoreHorizIcon from "@material-ui/icons/MoreHoriz";
import {openDialog} from '../../../slices/dialog';
import ButtonCircle from '../../Common/ButtonCircle';
import {EditCvJob} from '../../Dialog/Cv/EditJob';
import {Menu, MenuItem} from '@material-ui/core';
import {useTranslation} from 'react-i18next';
import {selectRole} from '../../../slices/profile';

const CvJobs = (props) => {
    const dispatch = useDispatch();
    const jobs = props.jobs;
    const docId = props.docId;
    const editable = props.editable;
    const {t} = useTranslation();

    const addBgItem = (type) => {
        dispatch(openDialog({
            Content: EditCvJob,
            title: t("student_job_title"),
            props: {
                docId
            },
            closable: true
        }));
    };

    return (
        <div className="cvJobs card">
            <div className={jobs.length > 0 ? "card__header border" : 'card__header'}>
                <h2 className="card__header__title">{t("student_profile_job_label")}</h2>
                {editable && <ButtonCircle onClick={() => addBgItem("JOB")}><AddIcon/></ButtonCircle>}
            </div>
            <div className="card__content">
                {jobs.map((job) => (
                    <CvJob
                        key={job.id}
                        job={job}
                        editable={editable}
                        docId={docId}
                        missing={false}
                    />
                ))}
            </div>
        </div>
    );
};

export const CvJob = ({job, editable, docId, missing}) => {
    const {t} = useTranslation();
    const dispatch = useDispatch();
    const role = useSelector(selectRole);
    const begin = job?.begin ? moment(job.begin.seconds * 1000).format("MM.YYYY") : "";
    const end = job?.end ? moment(job.end.seconds * 1000).format("MM.YYYY") : "oggi";
    const label = job?.label || "";
    const scope = job?.scopeId != null ? t(professionScopes[job.scopeId].label) : "";
    const contract = job?.contractId != null ? t(jobContracts[job.contractId].label) : "";
    const place = job?.place || "";
    const desc = job?.description || "";
    const [menuAnchor, setMenuAnchor] = useState(null);

    const onMenuOpen = (event) => {
        setMenuAnchor(event.currentTarget);
    };

    const onMenuClose = () => {
        setMenuAnchor(null);
    };

    const onUpdateBgItem = () => {
        onMenuClose();
        dispatch(openDialog({
            Content: EditCvJob,
            title: t("student_job_title"),
            props: {
                job,
                docId
            },
            closable: true
        }));
    };

    const onItemDelete = () => {
        onMenuClose();
        deleteBgItem(docId, job.id, "JOB", role);
    };

    return (
        <div className={missing === true ? "card__item missing" : "card__item"}>
            <div className="card__item__content">
                <h2 className="title">{label}</h2>
                <p className="regular">{place}</p>
                <p className="light">{begin}{end && " - " + end}</p>
                <p className="light">{scope}{contract && ' | ' + contract}</p>
                <div dangerouslySetInnerHTML={{__html: desc}} />
            </div>
            {editable && (
                <div className="cvItemOptions">
                    <ButtonCircle light aria-controls="menu" aria-haspopup="true" onClick={onMenuOpen}><MoreHorizIcon/></ButtonCircle>
                    <Menu
                        id="menu"
                        anchorEl={menuAnchor}
                        keepMounted
                        open={Boolean(menuAnchor)}
                        onClose={onMenuClose}
                    >
                        <MenuItem onClick={onUpdateBgItem}>{t("student_profile_item_update")}</MenuItem>
                        <MenuItem onClick={onItemDelete}>{t("student_profile_item_delete")}</MenuItem>
                    </Menu>
                </div>
            )}
        </div>
    );
};

export default CvJobs;